import * as R from 'ramda';

export default function PreparationItemCategoryController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  editPreparationItemCategoryDialog,
  editPreparationItemDialog,
  loaderService,
  orgDataService,
  ssDialogService,
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = true;
  vm.isExpanded = false;

  vm.canEditItem = vm.preparationItemCategory.canEdit && vm.auditIsActive;
  vm.canDeleteItem = vm.preparationItemCategory.canDelete && vm.auditIsActive;

  // Attach Event Handlers
  vm.handleExpandPreparationItemCategory = _handleExpandPreparationItemCategory;
  vm.handleEditPreparationItemCategory = _handleEditPreparationItemCategory;
  vm.handleDeletePreparationItemCategory = _handleDeletePreparationItemCategory;
  vm.handleAddPreparationItem = _handleAddPreparationItem;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;
  vm.handleDeletedPreparationItem = _handleDeletedPreparationItem;

  _initEventListeners();
  _activate();

  /** **********************************************
   * Event Handlers
   */

  function _handleExpandPreparationItemCategory() {
    if (!vm.isExpanded) {
      _loadPreparationItems().then(() => {
        vm.isExpanded = true;
      });
    } else {
      vm.isExpanded = false;
    }
  }

  function _handleEditPreparationItemCategory($event) {
    return amDataService.getPreparationItemCategory(vm.preparationItemCategory.preparationItemCategoryId)
      .then(() => {
        ssDialogService.dialogs.auditTrail.editPreparationItemCategoryDialog = ssDialogService.alert(
          editPreparationItemCategoryDialog.getOptions($event, {
            preparationItemCategory: vm.preparationItemCategory,
          }),
        );
        return ssDialogService.show(ssDialogService.dialogs.auditTrail.editPreparationItemCategoryDialog);
      });
  }

  function _handleAddPreparationItem($event) {
    return amDataService.getDefaultPreparationItem(
      vm.preparationItemCategory.preparationItemCategoryId
    ).then((response) => {
      ssDialogService.dialogs.auditTrail.editPreparationItemDialog = ssDialogService.alert(
        editPreparationItemDialog.getOptions($event, {
          customerId: vm.customerId,
          auditId: vm.auditId,
          users: vm.users,
          statuses: vm.statuses,
          preparationItem: response.data,
          addCallback: _handleAddedPreparationItem,
        }),
      );
      return ssDialogService.show(ssDialogService.dialogs.auditTrail.editPreparationItemDialog);
    });
  }

  function _handleDeletePreparationItemCategory($event) {
    ssDialogService.dialogs.auditTrail.deletePreparationItemCategoryConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Preparation Item Category?',
        message: `Are you sure you want to delete Preparation Item Category "${vm.preparationItemCategory.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      }),
    );
    return ssDialogService.show(
      ssDialogService.dialogs.auditTrail.deletePreparationItemCategoryConfirmDialog,
    );
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.deletePreparationItemCategory(vm.preparationItemCategory.preparationItemCategoryId)
      .then(() => {
        alerts.success('The Preparation Item Category has been deleted successfully.');
        $rootScope.$broadcast('refreshAMPreparationItemCategories', { auditId: vm.auditId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Preparation Item Category.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _handleDeletedPreparationItem(preparationItem) {
    if (!preparationItem) return;
    const pos = vm.preparationItems.findIndex(item => item.preparationItemId === preparationItem.preparationItemId);
    if (pos === -1) return; // Can't find the item
    vm.preparationItems.splice(pos, 1);
  }

  /** **********************************************
   * Private Functions
   */

  function _activate() {
    const dfdActivate = $q.defer();

    _initEventListeners();
    _refreshPreparationItemStatuses().then(
      _refreshUsers().then(dfdActivate.resolve),
    );
  }

  function _initEventListeners() {
    $scope.$on('refreshAMUsers', _refreshUsers);

    $scope.$on('refreshAMPreparationItems', (event, opt) => {
      if (opt.preparationItemCategoryId === vm.preparationItemCategory.preparationItemCategoryId) {
        _loadPreparationItems();
      }
    });

    $scope.$on('refreshAMPreparationItemCategory', (event, opt) => {
      if (opt.preparationItemCategoryId === vm.preparationItemCategory.preparationItemCategoryId) {
        _refreshPreparationItemCategory();
        _loadPreparationItems();
      }
    });
  }

  function _handleAddedPreparationItem(preparationItem) {
    vm.preparationItems = vm.preparationItems || [];
    vm.preparationItems.push(preparationItem);
    if (vm.preparationItems.length > 1) {
      vm.preparationItems = amSharedModelService.sortByName(vm.preparationItems);
    }
    _setPreparationItemAttributes();
  }

  function _refreshPreparationItemCategory() {
    return amDataService.getPreparationItemCategory(vm.preparationItemCategory.preparationItemCategoryId)
      .then((response) => {
        vm.preparationItemCategory = response.data;
      });
  }

  function _loadPreparationItems() {
    loaderService.showViewLoader = true;
    return amSharedModelService.getPreparationItems(vm.preparationItemCategory.preparationItemCategoryId)
      .then((preparationItems) => {
        loaderService.showViewLoader = false;
        vm.preparationItems = preparationItems;
        _setPreparationItemAttributes();
      });
  }

  function _setPreparationItemAttributes() {
    R.forEach((preparationItem) => {
      preparationItem.canAddItemNote = (preparationItem.canAddNote || preparationItem.isAssignedToMe)
        && vm.auditIsActive;
      preparationItem.canAttachItemItems = (preparationItem.canAttachItems || preparationItem.isAssignedToMe)
        && vm.auditIsActive;
      preparationItem.canChangeItemStatus = (preparationItem.canChangeStatus || preparationItem.isAssignedToMe
        || preparationItem.canEdit) && preparationItem.statusId !== 3 && vm.auditIsActive;
      preparationItem.canEditItem = preparationItem.canEdit && vm.auditIsActive;
      preparationItem.canDeleteItem = preparationItem.canDelete && vm.auditIsActive;
    }, vm.preparationItems);
  }


  function _refreshUsers() {
    const dfdRefresh = $q.defer();

    vm.users = amSharedModelService.applicationUsers;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _refreshPreparationItemStatuses() {
    const dfdRefresh = $q.defer();

    vm.statuses = amSharedModelService.preparationItemStatuses;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _closeDeleteDialog() {
    return ssDialogService.hide(
      ssDialogService.dialogs.auditTrail.deletePreparationItemCategoryConfirmDialog,
    );
  }
}

PreparationItemCategoryController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'editPreparationItemCategoryDialog',
  'editPreparationItemDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
];
